import type { AnalyticsPeriod } from '@/lib/api';

interface PeriodSelectorProps {
  period: AnalyticsPeriod;
  onChange: (period: AnalyticsPeriod) => void;
  onRefresh: () => void;
  loading: boolean;
}

const PERIODS: AnalyticsPeriod[] = ['7d', '30d', '90d'];

export function PeriodSelector({ period, onChange, onRefresh, loading }: PeriodSelectorProps) {
  return (
    <div className="flex items-center gap-2">
      {PERIODS.map((p) => (
        <button
          key={p}
          onClick={() => onChange(p)}
          className={`px-3 py-1.5 text-sm rounded-md ${
            period === p
              ? 'bg-primary text-primary-foreground'
              : 'bg-muted text-muted-foreground hover:bg-accent'
          }`}
        >
          {p === '7d' ? '7 Days' : p === '30d' ? '30 Days' : '90 Days'}
        </button>
      ))}
      <button
        onClick={onRefresh}
        disabled={loading}
        className="px-3 py-1.5 text-sm bg-muted text-muted-foreground hover:bg-accent rounded-md disabled:opacity-50"
      >
        Refresh
      </button>
    </div>
  );
}
